import { loyaltyDomainStore } from '../../store';
export const getMemberHash = () => loyaltyDomainStore.data.memberHash;
